import React from 'react';
import PageHero from './PageHero';
import './Partnership.css';

const Partnership = () => {
  return (
    <>
      <PageHero
        sectionId="partnership"
        title="Partner With Us"
        subtitle="Invest in Innovation"
        description="Join Rivontrix on our journey to revolutionize enterprise cybersecurity and AI solutions globally. Partner with us to expand our vision and create transformative impact together."
        image="https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=1600&q=90&auto=format"
        gradient="linear-gradient(135deg, rgba(102, 126, 234, 0.9), rgba(118, 75, 162, 0.9))"
      />
      <section id="partnership" className="partnership">
        <div className="container">
          <div className="partnership-content">
            <div className="partnership-intro">
              <h2 className="section-title">Global Expansion & Strategic Partnerships</h2>
              <p className="section-description">
                Rivontrix is expanding globally, and we're seeking strategic partners and investors who share our vision 
                of delivering next-generation AI-driven cybersecurity and digital transformation solutions. Join us in building 
                the future of enterprise technology.
              </p>
            </div>

            <div className="partnership-types">
              <div className="partnership-card">
                <div className="partnership-icon">
                  <i className="fas fa-handshake"></i>
                </div>
                <h3>Strategic Partnerships</h3>
                <p>Collaborate with Rivontrix to deliver integrated solutions, expand market reach, and create innovative offerings that combine our expertise with your capabilities.</p>
                <ul className="benefits-list">
                  <li><i className="fas fa-check-circle"></i> Technology integrations</li>
                  <li><i className="fas fa-check-circle"></i> Joint go-to-market strategies</li>
                  <li><i className="fas fa-check-circle"></i> Co-innovation projects</li>
                  <li><i className="fas fa-check-circle"></i> Channel partnerships</li>
                </ul>
              </div>

              <div className="partnership-card featured">
                <div className="partnership-icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <h3>Investment Opportunities</h3>
                <p>Invest in Rivontrix's growth journey as we scale globally. Our innovative AI cybersecurity products, expanding client base, and proven expertise make us an attractive investment opportunity.</p>
                <ul className="benefits-list">
                  <li><i className="fas fa-check-circle"></i> Equity investment opportunities</li>
                  <li><i className="fas fa-check-circle"></i> Strategic funding rounds</li>
                  <li><i className="fas fa-check-circle"></i> Global expansion support</li>
                  <li><i className="fas fa-check-circle"></i> Technology R&D investments</li>
                </ul>
              </div>

              <div className="partnership-card">
                <div className="partnership-icon">
                  <i className="fas fa-globe-americas"></i>
                </div>
                <h3>Global Expansion</h3>
                <p>Partner with us to bring Rivontrix's solutions to new markets. We're seeking regional partners, distributors, and resellers to expand our global footprint.</p>
                <ul className="benefits-list">
                  <li><i className="fas fa-check-circle"></i> Regional distribution partnerships</li>
                  <li><i className="fas fa-check-circle"></i> Market entry support</li>
                  <li><i className="fas fa-check-circle"></i> Localization partnerships</li>
                  <li><i className="fas fa-check-circle"></i> Joint venture opportunities</li>
                </ul>
              </div>
            </div>

            <div className="why-invest">
              <h2 className="section-title">Why Invest in Rivontrix?</h2>
              <div className="value-propositions">
                <div className="value-card">
                  <div className="value-number">1</div>
                  <h3>Innovative Products</h3>
                  <p>ShieldEx - our AI-powered cybersecurity platform, leverages cutting-edge GenAI and machine learning to provide superior threat detection and response.</p>
                </div>

                <div className="value-card">
                  <div className="value-number">2</div>
                  <h3>Proven Expertise</h3>
                  <p>Expertise across cybersecurity, GenAI, cloud migration, and digital transformation with a track record of successful enterprise implementations.</p>
                </div>

                <div className="value-card">
                  <div className="value-number">3</div>
                  <h3>Growing Market</h3>
                  <p>The global cybersecurity and AI markets are experiencing unprecedented growth, with increasing demand for AI-driven security solutions.</p>
                </div>

                <div className="value-card">
                  <div className="value-number">4</div>
                  <h3>Global Vision</h3>
                  <p>Clear roadmap for global expansion across key markets, with established presence in Singapore and plans for regional expansion.</p>
                </div>

                <div className="value-card">
                  <div className="value-number">5</div>
                  <h3>Strong Team</h3>
                  <p>Experienced leadership team with deep domain expertise in cybersecurity, AI, cloud technologies, and enterprise solutions.</p>
                </div>

                <div className="value-card">
                  <div className="value-number">6</div>
                  <h3>Diverse Revenue</h3>
                  <p>Multiple revenue streams: product sales (ShieldEx), consulting services, and talent placement through TechTalentPro.</p>
                </div>
              </div>
            </div>

            <div className="cta-section">
              <div className="cta-content">
                <h2>Ready to Partner or Invest?</h2>
                <p>
                  Whether you're interested in strategic partnerships, investment opportunities, or global expansion collaborations, 
                  we'd love to discuss how we can work together to create transformative impact.
                </p>
                <div className="cta-buttons">
                  <a 
                    href="#contact" 
                    className="btn btn-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      const event = new CustomEvent('sectionChange', { detail: 'contact' });
                      window.dispatchEvent(event);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  >
                    Get in Touch
                    <i className="fas fa-arrow-right"></i>
                  </a>
                  <a 
                    href="#contact" 
                    className="btn btn-secondary"
                    onClick={(e) => {
                      e.preventDefault();
                      const event = new CustomEvent('sectionChange', { detail: 'contact' });
                      window.dispatchEvent(event);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  >
                    Schedule a Meeting
                    <i className="fas fa-calendar"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Partnership;


